__turbopack_context__.v({
  "className": "libre_baskerville_64aae1df-module__KJXZ4q__className",
  "variable": "libre_baskerville_64aae1df-module__KJXZ4q__variable",
});
